interface WeChatType {
	oauth: () => string;
}
interface CryptoType {
	publickey: string;
}
interface CookieType {
	expires: string;
	name: string;
	path?: string;
}
interface MonitorType {
	autoView: boolean;
	url: string;
	user_name: string;
}
interface JssdkType {
	url: string;
	jsApiList: string[];
}
export interface ConfigType {
	appid: string;
	storagePrefix?: string;
	wechat: WeChatType;
	crypto: CryptoType;
	monitor: MonitorType;
	jssdk: JssdkType;
}

const config: ConfigType = {
	appid: 'wxd0e450f42accad28', // 公众号appid
	storagePrefix: 'ab3ac6e1-', // node识别自动生成uuid
	wechat: {
		oauth: function() {
			const website_url = encodeURIComponent(window.location.href);
			return `https://evonik-ev-3d.blue-dot.com.cn/api/platform/wechat/auth?website_url=${website_url}`;
		}
	},
	jssdk: {
		url: 'https://api.lookstar.com.cn/tenant/open-api/wechat/jssdk',
		jsApiList: ['onMenuShareTimeline', 'updateTimelineShareData', 'onMenuShareAppMessage', 'updateAppMessageShareData', 'hideMenuItems']
	},
	crypto: {
		publickey: `-----BEGIN PUBLIC KEY-----
		MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAoxLPWyo4lWU3bZAJGDYa
		YzZJHsmrdfAERtZxKM6xoPrRM752/pYvIxWNIMD9hsjh+yLZw1HGtDPLkWkg/XDP
		u9LMBaRhCdRYy+bgroUAuhJBnqfwoY/DXet4/FNGz58UnPrDjamERLPMyY23VEI+
		Frk1Kdh7eF4MyPEUcOlbpCh9qS1TlVVsmHNn5dl/WWKI06PkD3F5iFPXdDyadMV7
		npvXmpOFQ/Iw4tBTe9/f7gObaw2GJikI1AxTtTK0nYGL8QUdyEIeGGSd13dOigfd
		ooqT7WzKiRLb1mX+pwLXI2uMMEvU8Dk3yF3oRV3D7+kHjtTw8ggYKfZtnE7AtY4c
		ZGjL2VBHTSxcyOYJOzZq9J2wsC7mSfRBDUII6RM3/iG54EhitV2QEYYfHGskR/nN
		FwNm8xHgPzfWv4C+vAwiGCNTcG2XjSPDVMNGDIASRHz0T53Y3JUzIcmCJeK/Iu9Q
		KqnUAE61o/9/ixn3/xyL4ayiNChusSt5F77P1QwCbDescnz0mpDFbFnLjXIyEo7Y
		U7KBOWMOsxP7gh90a0Yjsd8al+fWBzCsZxCA0HNjSEv6xrovmYBrXCTGcJ2xB+fr
		CmiVOnwzuKgPA8psQB7l4+B9Uzf86kCLABSFZ93cVW4ZLzd8nqQb8mdVH++8FCl8
		H+MYLp1P5SIi9Xg/CrUHK/ECAwEAAQ==
		-----END PUBLIC KEY-----`
	},
	monitor: {
		// 这些信息全部向后台要
		autoView: true, // 是否开启页面自动监测
		url: '/api/platform/monitor',
		user_name: ''
	}
};

export default config;
